import React, { useState } from "react"
import {graphql, useStaticQuery} from "gatsby"

import winStyles from './team_win_total_table.module.scss'
import SortableTable from "../table"
import TopTableBar from "../Extras/top_bar"


const WinTable = () => {

    // temp fillers for testing //
    const tempFields = [
        {
            'displayName' : 'Season',
            'refName' : 'season',
            'fieldGroup' : 'Team Info',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'Coach',
            'refName' : 'coach',
            'fieldGroup' : 'Team Info',
            'displayType' : 'AbrName',
            'displayParams' : {'rem' : .8},
        },
        {
            'displayName' : 'QB',
            'refName' : 'qb_name',
            'fieldGroup' : 'Team Info',
            'displayType' : 'AbrName',
            'displayParams' : {'rem' : .8},
        },
        {
            'displayName' : 'Actual',
            'refName' : 'wins',
            'fieldGroup' : 'Wins',
            'displayType' : 'AsInt',
            'displayParams' : {},
        },
        {
            'displayName' : 'Vegas Total',
            'refName' : 'line',
            'fieldGroup' : 'Wins',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'Adj. Total',
            'refName' : 'line_adj',
            'fieldGroup' : 'Wins',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'Result',
            'refName' : 'total_outcome',
            'fieldGroup' : 'Wins',
            'displayType' : 'TotalStatus',
            'displayParams' : {},
        },
        {
            'displayName' : 'Over',
            'refName' : 'over_odds',
            'fieldGroup' : 'Odds',
            'displayType' : 'AmericanOdds',
            'displayParams' : {},
        },
        {
            'displayName' : 'Under',
            'refName' : 'under_odds',
            'fieldGroup' : 'Odds',
            'displayType' : 'AmericanOdds',
            'displayParams' : {},
        },
        {
            'displayName' : 'Hold',
            'refName' : 'hold',
            'fieldGroup' : 'Odds',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'Over',
            'refName' : 'over_probability',
            'fieldGroup' : 'Implied Probability',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'Under',
            'refName' : 'under_probability',
            'fieldGroup' : 'Implied Probability',
            'displayType' : 'AsPct',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'Team',
            'refName' : 'wt_rating',
            'fieldGroup' : 'Implied Strength',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 1},
        },
        {
            'displayName' : 'Openent',
            'refName' : 'sos_projected',
            'fieldGroup' : 'Implied Strength',
            'displayType' : 'AsFloat',
            'displayParams' : {'percision' : 1},
        },
    ]

    const defaultSort = [{
        'field' : 'line_adj',
        'direction' : 'dsc'
    }]


    // data //
    const data = useStaticQuery(graphql`
        query {
            allSosCsv {
                nodes {
                    team
                    season
                    qb_name
                    coach
                    line
                    line_adj
                    over_odds
                    under_odds
                    team_nick
                    team_color
                    team_color2
                    team_logo_espn
                    wins
                    total_outcome
                    hold
                    over_probability
                    under_probability
                    unique_id
                    wt_rating
                    sos_projected
                }
            }
        }      
    `)
    
    // unique values for filtering //

    const seasons = []
    const teams = []
    const coaches = []
    const qbs = []

    data.allSosCsv.nodes.forEach((row) => {

        if (!seasons.includes(row['season'])) {
            seasons.push(row['season'])
        }

        if (!teams.includes(row['team_nick'])) {
            teams.push(row['team_nick'])
        }

        if (!coaches.includes(row['coach'])) {
            coaches.push(row['coach'])
        }

        if (!qbs.includes(row['qb_name'])) {
            qbs.push(row['qb_name'])
        }
    })

    // translate into dropdown options //
    const seasonOptions = seasons.map((row) => {
        return (
            {'value' : parseInt(row), 'label' : row}
        )
    })
    const teamOptions = teams.map((row) => {
        return (
            {'value' : row, 'label' : row}
        )
    })
    const coachOptions = coaches.map((row) => {
        return (
            {'value' : row, 'label' : row}
        )
    })
    const qbOptions = qbs.map((row) => {
        return (
            {'value' : row, 'label' : row}
        )
    })

    // starting vals //
    const currentSeason = Math.max(...seasons)

    // drop states //
    // in logic, if array is blank, then we will take all //
    const [selectedSeasons, setSelectedSeasons] = useState([
        {'value' : currentSeason, 'label' : currentSeason}
    ])
    const [selectedTeams, setSelectedTeams] = useState([])
    const [selectedCoaches, setSelectedCoaches] = useState([])
    const [selectedQbs, setSelectedQbs] = useState([])
    
    // filter data //
    // first create arrays of selected values that can be checked //
    // as we iterate over the dataset //

    // seasons //
    const seasonVals = selectedSeasons.map((season) => {
        return(
            season['value']
        )
    })

    // teams //
    const teamVals = selectedTeams.map((team) => {
        return(
            team['value']
        )
    })

    // teams //
    const coachVals = selectedCoaches.map((coach) => {
        return(
            coach['value']
        )
    })

    // teams //
    const qbVals = selectedQbs.map((qb) => {
        return(
            qb['value']
        )
    })

    const filteredData = data.allSosCsv.nodes.filter((row) => {

        // boolean to toggle if row is included //
        var includeBool = 1

        // seasons //
        if ((seasonVals.length === 0 && parseInt(row['season']) === currentSeason) || seasonVals.includes(parseInt(row['season']))) {
        
        } else {
            includeBool = includeBool * 0
        }

        // teams //
        if (teamVals.length === 0 || teamVals.includes(row['team_nick'])) {

        } else {
            includeBool = includeBool * 0
        }

        // coaches //
        if (coachVals.length === 0 || coachVals.includes(row['coach'])) {

        } else {
            includeBool = includeBool * 0
        }

        // qbs //
        if (qbVals.length === 0 || qbVals.includes(row['qb_name'])) {

        } else {
            includeBool = includeBool * 0
        }
                    
        // if bool still 1 after filters, then add //
        if (includeBool === 1) {
            return (true)
        } else {
            return (false)
        }

    })


    const tableFilters = [
        {
            'filterId' : 'seasons',
            'filterName' : 'Seasons',
            'filterType' : 'multiSelect',
            'filterParams' : {
                'options' : seasonOptions,
                'onChange' : setSelectedSeasons,
                'values' : selectedSeasons,
                'default' : null
            }
        },
        {
            'filterId' : 'teams',
            'filterName' : 'Teams',
            'filterType' : 'multiSelect',
            'filterParams' : {
                'options' : teamOptions,
                'onChange' : setSelectedTeams,
                'values' : selectedTeams,
                'default' : null
            }
        },
        {
            'filterId' : 'coaches',
            'filterName' : 'Coaches',
            'filterType' : 'multiSelect',
            'filterParams' : {
                'options' : coachOptions,
                'onChange' : setSelectedCoaches,
                'values' : selectedCoaches,
                'default' : null
            }
        },
        {
            'filterId' : 'qbs',
            'filterName' : 'QBs',
            'filterType' : 'multiSelect',
            'filterParams' : {
                'options' : qbOptions,
                'onChange' : setSelectedQbs,
                'values' : selectedQbs,
                'default' : null
            }
        },
    ]


    return (

        <div className={winStyles.team_container}>
            <TopTableBar
                tableData={filteredData}
                ignores={[]}
                fileName={'nfl-win-totals.csv'}
                filters={tableFilters}
            />
            <div className={winStyles.team_table_container}>
                <SortableTable
                    records={filteredData}
                    fields={tempFields}
                    plateType={'teamSeason'}
                    defaultSort={defaultSort}
                    linkType={'none'}
                    idField={'unique_id'}
                />    
            </div>
        </div>
    )
}

export default WinTable